export default __webpack_public_path__ + "images/bfa2dc5fe67e045dfca14ec587982881-basketball.webp";